module.exports = __webpack_public_path__ + "img/banner_cpbz.c03d1117.png";